import { useContext } from "react";
import { LanguageContext } from "../i18n/LanguageContext";

export default function useI18n() {
    const { l, language, changeLanguage } = useContext(LanguageContext);
    return { l, language, changeLanguage };
}
